<template>
    <div>
        <button
                tabindex="0"
                class="hamburger"
                :class="isOpen && 'is-open'"
                @click="handleBtnClick"
                @focusin="isFocused = true"
                @focusout="isFocused = false"
                :aria-pressed="isOpen ? 'true' : 'false'"
                aria-label="Menyknapp"
        >
            <div class="hamburger-inner"></div>
        </button>
        <div role="menu" class="menu-container" :class="isOpen && 'is-open'" :aria-expanded="isOpen ? 'true' : 'false'" aria-owns="menu-wrapper">
            <ul class="menu-wrapper" id="menu-wrapper" v-if="isOpen">
                <li class="menu-item" @keyup.tab="isOpen = true">
                    <a href="/">Startsidan</a>
                </li>
                <li class="menu-item">
                    <a href="/om-oss/">Om oss</a>
                </li>
                <li class="menu-item">
                    <a href="/kontakta-oss/">Kontakta oss</a>
                </li>
                <li class="menu-item">
                    <a href="/kulturarvsaktorer/">Kulturarvsaktörer i Västmanland</a>
                </li>
                <li class="menu-item">
                    <a href="/bidra/">Bidra med material</a>
                </li>
                <li class="menu-item">
                    <a href="/kulturmiljounderlag/">Kulturmiljöunderlag</a>
                </li>
                <li class="menu-item" @keydown.tab="handleTab">
                    <a href="/vad-ar-kulturarv/">Vad är kulturarv?</a>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
  name: 'MenuComponent',

  data () {
    return {
      isOpen: false,
      isFocused: false
    }
  },

  methods: {
    handleBtnClick: function () {
      this.isOpen = !this.isOpen
    },

    handleTab: function () {
      this.isOpen = false
    }
  }
}
</script>

<style scoped>

</style>
